<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Raw Materials Usage Report</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete style="width: 500px" autocomplete="off" v-model="record.ProductId"
                :items="rawMaterialProducts" :search-input.sync="searchRawMaterials" item-text="Name" item-value="id"
                cache-items flat hide-no-data hide-details label="Search Raw Materials" outlined dense></v-autocomplete>
            </v-col>

            <v-col cols="6" xs="6" md="3">
              <v-btn :loading="loader" @click="getReport" color="accent">Generate Report</v-btn>
            </v-col>

            <v-col cols="6">
              <v-btn text @click="generateRawMaterialsPdf" color="primary">
                <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print
                Pdf Report
              </v-btn>
            </v-col>

            <v-col cols="6">
              <span class="style-16 float-right" style="margin-right: 30px">Total: {{ TotalValue | currency }}</span>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-text-field label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-data-table :items-per-page="2000" :mobile-breakpoint="zeroValue" :headers="headers" :items="reportData"
                :search="search">
                <template v-slot:item.Price="{ item }">
                  <span v-if="item.Price">
                    {{
                      item.Price.toLocaleString()
                    }}
                  </span>
                </template>
                <template v-slot:item.CostOfSales="{ item }">
                  <span>{{ item.BuyingPrice * item.Quantity }}</span>
                </template>
                <template v-slot:item.LineTotal="{ item }">
                  <span v-if="item.LineTotal">
                    {{
                      item.LineTotal.toLocaleString()
                    }}
                  </span>
                </template>
                <template v-slot:item.LineProfit="{ item }">
                  <span v-if="item.LineProfit">
                    {{
                      item.LineProfit.toLocaleString()
                    }}
                  </span>
                </template>

                <template v-slot:item.date="{ item }">
                  <span style="min-width: 80px; display: inline-block">
                    {{
                      item.date | date
                    }}
                  </span>
                </template>
              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>

          <v-row>
            <v-divider></v-divider>
          </v-row>

          <!-- pdf preview -->
          <pdf-preview ref="pdfPreview"></pdf-preview>
          <!-- end -->
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      record: {},
      TotalValue: 0,
      searchRawMaterials: null,
      rawMaterialProducts: [],
      pageItems: 500,
      IMEI: null,
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      zeroValue: 0,
      products: [],
      customers: [],
      reportData: [],
      TotalProfit: null,
      TotalQuantitySold: null,
      brands: [],
      categories: [],
      returnsData: [],
      TotalReturns: null,
      drivers: [],
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit of Measure", value: "UOM.UomName" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Date", value: "date" }
      ],
      fields: {
        Product: "product.Name",
        Quantity: "Quantity",
        Unit: "uom.UomName",
        User: "user.name",
        Date: "DocDate",
      }
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalSales() {
      let total = 0;
      if (this.reportData.TotalSalesAmount) {
        total = this.reportData.TotalSalesAmount;
      }
      return total.toLocaleString();
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  watch: {
    searchRawMaterials(val) {
      if (val && val !== this.select && this.queryRawMaterials(val)) {
        this.queryRawMaterials(val);
      }
    }
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    generateRawMaterialsPdf() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select dates range", "red");
        return;
      }

      var url = "/print-raw-materials-report";
      const apiUrl = `${host}${url}`;

      const self = this;

      var data = {
        "StartDate": self.record.StartDate,
        "EndDate": self.record.EndDate,
        "ProductId": self.record.ProductId,
      }

      http.post(apiUrl, data, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        console.log(' invoice file url', fileUrl);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    queryRawMaterials(searchText) {
      const self = this;
      const url = "/search-raw-materials";
      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.rawMaterialProducts = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/products`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      const url = "/get-raw-materials-used";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData.rawMaterials;
            self.TotalValue = res.ResponseData.totalValue;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() {
      const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      var totalPagesExp = "{total_pages_count_string}";
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      doc.text(shopName, pageWidth - 50, 15, "center");

      //Setting Items Title:
      doc.setFontSize(15);
      doc.text("Sold Products Report", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        `From: ${this.record.StartDate}  To:  ${this.record.EndDate}`,
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataRows = [];
      let dataSummaryRows = [];

      // Columns
      var columns = [
        { title: "Product", dataKey: "Name" },
        { title: "Quantity", dataKey: "Quantity" },
        { title: "Buying Price", dataKey: "BuyingPrice" },
        { title: "Cost Of Sales", dataKey: "CostOfSales" },
        { title: "Selling Price", dataKey: "Price" },
        { title: "Total Sales", dataKey: "LineTotal" },
        { title: "Profit Margin", dataKey: "LineProfit" },
        { title: "Doc Date", dataKey: "DocDate" }
      ];

      function dataSummaryColumns() {
        return [
          {
            count: "",
            name: "Amount"
          }
        ];
      }

      const TotalSalesAmount = {
        count: "Total Sales Amount",
        name: this.totalSales
      };

      const formattedProfit = this.TotalProfit.toLocaleString();
      const TotalProfitAmount = {
        count: "Total Profit",
        name: formattedProfit
      };

      dataSummaryRows.push(TotalSalesAmount);
      dataSummaryRows.push(TotalProfitAmount);

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("SUMMARY", 15, 68);
      doc.autoTable({
        head: dataSummaryColumns(),
        body: dataSummaryRows,
        theme: "grid",
        tableWidth: 80,
        columnStyles: {
          count: {
            fontStyle: "bold"
          }
        },
        startY: 70,
        styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
        margin: { right: 100 }
      });

      const allSales = this.reportData.AllProductsSold;
      dataRows = allSales.map(alldata => {
        const CostOfSales = (
          alldata.Quantity * alldata.BuyingPrice
        ).toLocaleString();
        return {
          Name: alldata.product.Name,
          Quantity: alldata.Quantity,
          BuyingPrice: alldata.BuyingPrice.toLocaleString(),
          CostOfSales: CostOfSales,
          Price: alldata.Price.toLocaleString(),
          LineTotal: alldata.LineTotal.toLocaleString(),
          LineProfit: alldata.LineProfit.toLocaleString(),
          DocDate: alldata.DocDate
        };
      });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("DOCUMENTS", 15, doc.autoTable.previous.finalY + 8);
      doc.autoTable(columns, dataRows, {
        theme: "grid",
        startY: doc.autoTable.previous.finalY + 13,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
          //Setting Foouter
          doc.setTextColor(22, 160, 133);
          doc.setFontSize(10);
          var today = new Date();
          doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
        }
      });
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }
      doc.save("Sold-products-report.pdf");
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.IMEI = res.ResponseData.IMEI;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDrivers() {
      const self = this;
      this.$store
        .dispatch("get", `/drivers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.drivers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getCustomers(),
      this.getCategories(),
      this.getGenSettings(),
      // this.getBrands(),
      this.getProducts(),
      // this.getDrivers()
    ]);
  }
};
</script>

<style lang="scss" scoped></style>